

import React from "react";
import "./Home.css";

const contactMessage =
	"नमस्ते Network Educational Academy 🙏 म Network Educational Academy को प्रयोगकर्ता हुँ।";

const WithWhatsapp = ({ number, name }) => {
	const whatsappMessage = encodeURIComponent(contactMessage);

	return (
		<article className="contact-person-card">
			<div className="contact-person-info">
				<a
					href={`tel:+977${number}`}
					className="contact-phone-number"
				>
					{number}
				</a>

				<h3 className="contact-person-name">
					{name}
				</h3>
			</div>

			<div className="contact-action-list">
				<a
					href={`https://wa.me/977${number}?text=${whatsappMessage}`}
					target="_blank"
					rel="noopener noreferrer"
					className="contact-action contact-whatsapp"
					aria-label={`Message ${name} on WhatsApp`}
					title="WhatsApp"
				>
					<i className="fa fa-whatsapp" aria-hidden="true" />
				</a>

				<a
					href={`viber://chat?number=%2B977${number}`}
					className="contact-action contact-viber"
					aria-label={`Message ${name} on Viber`}
					title="Viber"
				>
					<img
						src="https://api.networkeducationalacademy.com/wp-content/uploads/2025/09/viber.jpg"
						alt=""
					/>
				</a>

				<a
					href={`tel:+977${number}`}
					className="contact-action contact-call"
					aria-label={`Call ${name}`}
					title="Call"
				>
					<i className="fa fa-phone" aria-hidden="true" />
				</a>
			</div>
		</article>
	);
};

const WithoutWhatsapp = ({ number }) => {
	return (
		<article className="landline-card">
			<div>


				<a
					href={`tel:${number}`}
					className="landline-number"
				>
					{number}
				</a>
				<span className="landline-label">
					Landline
				</span>
			</div>

			<a
				href={`tel:${number}`}
				className="contact-action contact-call"
				aria-label={`Call ${number}`}
				title="Call"
			>
				<i className="fa fa-phone" aria-hidden="true" />
			</a>
		</article>
	);
};

export default function ContactUSLogin() {
	return (
		<section className="contact-section">
			<div className="contact-section-header">
				<span className="contact-section-badge">
					सहायता
				</span>

				<h2 className="contact-section-title">
					Need help?
				</h2>

				<p className="contact-section-description">
					माथि दिइएको Course Folder मा Click गरेर तपाईंले
					लिइरहनुभएको कोर्ष Check गर्नुहोस्। केही समस्या भएमा
					Viber वा WhatsApp मा Message गर्नुहोस्।
				</p>
			</div>

			<div className="contact-person-grid">
				<WithWhatsapp
					number="9844832140"
					name="R.K. Sir"
				/>

				<WithWhatsapp
					number="9844085262"
					name="Nirajan Sir"
				/>
			</div>

			<div className="landline-section">
				<WithoutWhatsapp number="01-5921577" />
			</div>
		</section>
	);
}